var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"timeonly",attrs:{"type":"text","placeholder":"請選擇開始時間"},domProps:{"value":_vm.time}})}
var staticRenderFns = []

export { render, staticRenderFns }